// extracted by mini-css-extract-plugin
export default {"card":"NewCard_card__RHIyq","date":"NewCard_date__vuQn-","title":"NewCard_title__Lna47","btn":"NewCard_btn__5rMip","icon":"NewCard_icon__0O66y","social":"NewCard_social__LOOc7"};